<template>
    <el-scrollbar class="topic-discussion">
        <!-- 发布 -->
        <div class="topic-discussion_publish">
            <div class="publish-title">{{ discussionData.info.title }}</div>

            <div class="publish-input">
                <img :src="getAvatarSrc(roleData.avatar)" alt="" />

                <el-input
                    type="textarea"
                    placeholder="请输入话题"
                    v-model="discussionLabel"
                    :rows="4"
                    resize="none"
                    maxlength="500"
                    show-word-limit
                >
                </el-input>
            </div>

            <div class="publish-operate">
                <el-button type="primary" class="primary-button" @click="publishDiscussion">发布</el-button>
            </div>
        </div>

        <!-- 话题内容 -->
        <div class="topic-discussion_box">
            <div class="discussion-count">
                共
                <span>{{ discussionData.children.length }}</span>
                条话题
            </div>

            <div class="discussion-empty" v-if="discussionData.children.length === 0">
                <img src="@/assets/images/discussion-empty.png" alt="" />
                <span>暂无话题</span>
            </div>

            <template v-else>
                <div class="discussion-item" v-for="(discussionItem, discussionIndex) in discussionData.children" :key="discussionItem.id">
                    <!-- 楼主 -->
                    <div class="discussion-item_landlord">
                        <img class="landlord-img" :src="getAvatarSrc(discussionItem.userinfo.avatar)" alt="" />

                        <div class="landlord-info">
                            <div :class="['landlord-info_top', { flex: discussionItem.isEdit }]">
                                <span class="top-sticky" v-if="discussionItem.index !== 0">置顶</span>

                                <span class="top-name">{{ discussionItem.userinfo.name }}</span>

                                <span class="top-text" v-if="!discussionItem.isEdit">{{ discussionItem.contents }}</span>
                                <el-input
                                    type="textarea"
                                    v-model="editLabel"
                                    :rows="3"
                                    resize="none"
                                    v-auto-focus="handieEditConfirm"
                                    maxlength="500"
                                    show-word-limit
                                    v-else
                                >
                                </el-input>
                            </div>

                            <div class="landlord-info_bottom">
                                <div class="bottom-time">
                                    <span>第{{ discussionIndex + 1 }}楼 {{ discussionItem.timer }}</span>
                                    <span class="bottom-time-operate" @click="handleReplyLandlord(discussionItem, discussionIndex)">
                                        回复
                                    </span>
                                </div>

                                <!-- 菜单 -->
                                <div class="bottom-operate">
                                    <!-- 点赞 -->
                                    <div class="bottom-operate_digg">
                                        <i
                                            :class="['iconfont', { 'is-digg': discussionItem.is_liked }]"
                                            @click="diggDiscussion(discussionItem)"
                                        >
                                            {{ discussionItem.is_liked ? "&#xec8c;" : "&#xe600;" }}
                                        </i>
                                        <span class="operate-count">{{ discussionItem.like_count || 0 }}</span>
                                    </div>

                                    <!-- 评论 -->
                                    <div class="bottom-operate_comment">
                                        <i class="iconfont" @click="handleReplyLandlord(discussionItem, discussionIndex)">&#xe60c;</i>
                                        <span class="operate-count">{{ discussionItem.reply_count || 0 }}</span>
                                    </div>

                                    <!-- 更多菜单 -->
                                    <div class="bottom-operate_more">
                                        <el-dropdown trigger="hover" placement="bottom" @command="handleCommand($event, discussionItem)">
                                            <div class="el-icon-more"></div>

                                            <el-dropdown-menu
                                                slot="dropdown"
                                                v-if="!(roleData.role === 4 && discussionItem.userinfo.id !== roleData.id)"
                                            >
                                                <el-dropdown-item
                                                    v-if="discussionItem.userinfo.id === roleData.id"
                                                    :command="{ type: 'edit', discussion: discussionItem, index: discussionIndex }"
                                                >
                                                    编辑
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    v-if="discussionItem.userinfo.id === roleData.id || roleData.role === 3"
                                                    :command="{ type: 'delete', discussion: discussionItem }"
                                                >
                                                    删除
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    v-if="roleData.role === 3"
                                                    :command="{ type: 'sticky', discussion: discussionItem }"
                                                >
                                                    {{ discussionItem.index !== 0 ? "取消置顶" : "置顶" }}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 回复 -->
                    <div class="discussion-item_comment">
                        <div class="discussion-reply" v-if="discussionItem.isReply" v-auto-focus="clearReplyInput">
                            <div class="publish-input">
                                <img :src="getAvatarSrc(roleData.avatar)" alt="" />

                                <el-input
                                    type="textarea"
                                    placeholder="请回复内容"
                                    v-model="replyLabel"
                                    :rows="3"
                                    resize="none"
                                    maxlength="500"
                                    show-word-limit
                                >
                                </el-input>
                            </div>

                            <div class="publish-operate">
                                <el-button type="primary" class="primary-button" @click="handleReplyConfirm">回复</el-button>
                            </div>
                        </div>

                        <div class="comment-item" v-for="(replyItem, replyIndex) in discussionItem.children" :key="replyItem.id">
                            <div :class="['comment-item_top', { flex: replyItem.isEdit }]">
                                <span class="top-name">
                                    {{ `${replyItem.userinfo.name}` }}

                                    <template v-if="replyItem.reply_to">
                                        <span class="top-name-reply">回复</span>
                                        {{ replyItem.reply_to }}
                                    </template>
                                </span>

                                <span class="top-text" v-if="!replyItem.isEdit">{{ replyItem.contents }}</span>
                                <el-input
                                    type="textarea"
                                    v-model="editLabel"
                                    :rows="3"
                                    resize="none"
                                    v-auto-focus="handieEditConfirm"
                                    maxlength="500"
                                    show-word-limit
                                    v-else
                                >
                                </el-input>
                            </div>

                            <div class="comment-item_bottom">
                                <div class="bottom-time">
                                    <!-- <span style="margin-right: 5px;">第{{ replyIndex + 2 }}楼</span> -->

                                    <span>{{ replyItem.timer }}</span>

                                    <span
                                        class="bottom-time-operate comment"
                                        @click="handleReplyItem(discussionItem, discussionIndex, replyItem, replyIndex)"
                                    >
                                        回复
                                    </span>

                                    <span
                                        class="bottom-time-operate edit"
                                        v-if="replyItem.userinfo.id === roleData.id"
                                        @click="handleEditItem(discussionItem, discussionIndex, replyItem, replyIndex)"
                                    >
                                        编辑
                                    </span>

                                    <span
                                        class="bottom-time-operate delete"
                                        v-if="replyItem.userinfo.id === roleData.id || roleData.role === 3"
                                        @click="deleteReply(replyItem)"
                                    >
                                        删除
                                    </span>
                                </div>
                            </div>

                            <div class="discussion-reply" v-if="replyItem.isReply" v-auto-focus="clearReplyInput">
                                <div class="publish-input">
                                    <img :src="getAvatarSrc(roleData.avatar)" alt="" />

                                    <el-input
                                        type="textarea"
                                        v-model="replyLabel"
                                        :placeholder="`回复${replyItem.userinfo.name}`"
                                        :rows="3"
                                        resize="none"
                                        maxlength="500"
                                        show-word-limit
                                    >
                                    </el-input>
                                </div>

                                <div class="publish-operate">
                                    <el-button type="primary" class="primary-button" @click="handleReplyConfirm">回复</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </el-scrollbar>
</template>

<script>
import { autoFocus } from "@/utils/directives.js";

export default {
    name: "TopicDiscussion",
    components: {},
    props: ["status"],
    data() {
        return {
            query: JSON.parse(localStorage.getItem("query")),
            roleData: {
                id: Number(localStorage.getItem("sId")) || Number(localStorage.getItem("s_id")),
                role: Number(localStorage.getItem("role")),
                name: localStorage.getItem("sUsername"),
                avatar: localStorage.getItem("sIcon") == "null" ? "" : localStorage.getItem("sIcon"),
            },
            discussionData: {
                info: { title: "" },
                children: [],
            },
            discussionLabel: "", // 话题内容
            replyLabel: "", // 回复内容
            replyParams: {
                discussionData: null,
                discussionIndex: -1,
                replyData: null,
                replyIndex: -1,
            },
            editLabel: "", // 编辑内容
            editParams: {
                discussionData: null,
                discussionIndex: -1,
                replyData: null,
                replyIndex: -1,
            },
        };
    },
    directives: {
        autoFocus: autoFocus,
    },
    created() {
        this.getDiscussionList();
    },
    computed: {
        // getReplyPlacholder() {
        //     let placeholder = "";
        //     const discussionIndex = this.replyParams.discussionIndex;
        //     const replyIndex = this.replyParams.replyIndex;
        //     try {
        //         const replyDiscussion = this.discussionData.children[discussionIndex].children[replyIndex];
        //         if (replyDiscussion) {
        //             placeholder = `回复 ${replyDiscussion.userinfo.name}`;
        //         }
        //     } catch (error) {
        //         console.error("get placeholder error: ", error);
        //     }
        //     return placeholder;
        // },
    },
    methods: {
        // 获取讨论详情
        getDiscussionList() {
            const params = {
                id: this.query.id,
            };

            this.$shttp.axiosPost(this.$api.discuss_list, params, (res) => {
                if (res.code === 200) {
                    this.discussionData = res.data;

                    // 排序-置顶，点赞，评价时间
                    this.discussionData.children = this.discussionData.children.sort((a, b) => {
                        if (a.index !== b.index) return 0;

                        const timeData = {
                            a: new Date(a.create_time),
                            b: new Date(b.create_time),
                        };

                        if (a.like_count !== b.like_count) {
                            return b.like_count - a.like_count;
                        } else {
                            return timeData.a - timeData.b;
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 获取头像路径
        getAvatarSrc(url) {
            return !!url ? url : require("@/assets/images/user_img.png");
        },

        // 发布话题
        publishDiscussion() {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            if (!this.discussionLabel) {
                this.$message.warning("请输入话题内容");
                return;
            }

            const params = {
                id: this.query.id,
                parent_id: this.discussionData.info.id,
                contents: this.discussionLabel,
            };

            this.$shttp.axiosPost(
                this.$api.discuss_add,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.discussionLabel = "";
                        this.getDiscussionList();
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        // 点赞回复
        diggDiscussion(discussion) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            const params = {
                id: discussion.activities_id,
                discuss_id: discussion.id,
            };

            this.$shttp.axiosPost(
                this.$api.discuss_like,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.getDiscussionList();
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        // 话题菜单事件
        handleCommand(command) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            const { type, discussion } = command;

            if (type === "edit") {
                this.editDiscussion(discussion, command.index);
            } else if (type === "delete") {
                this.deleteDiscussion(discussion);
            } else if (type === "sticky") {
                this.topDiscussion(discussion);
            }
        },

        // 置顶话题
        topDiscussion(discussion) {
            const params = {
                id: discussion.activities_id,
                discuss_id: discussion.id,
            };

            this.$shttp.axiosPost(
                this.$api.discuss_top,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.getDiscussionList();
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    this.$message.error(error.msg);
                },
            );
        },

        // 删除话题
        deleteDiscussion(discussion) {
            this.$confirm("是否删除该话题", "删除话题提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                customClass: "initial-message-box",
            }).then(() => {
                // console.log("discussion: ", discussion);
                const params = {
                    id: discussion.activities_id,
                    discuss_id: discussion.id,
                };

                this.$shttp.axiosPost(
                    this.$api.discuss_delete,
                    params,
                    (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.getDiscussionList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    },
                    (error) => {
                        const errorData = error.response.data;
                        this.$message.error(errorData.msg);
                    },
                );
            });
        },

        // 删除回复
        deleteReply(reply) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            this.$confirm("是否删除该回复", "删除回复提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                customClass: "initial-message-box",
            }).then(() => {
                const params = {
                    id: reply.activities_id,
                    discuss_id: reply.id,
                };

                this.$shttp.axiosPost(
                    this.$api.discuss_delete,
                    params,
                    (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.getDiscussionList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    },
                    (error) => {
                        const errorData = error.response.data;
                        this.$message.error(errorData.msg);
                    },
                );
            });
        },

        // 编辑话题
        editDiscussion(discussion, index) {
            if (this.editParams.discussionIndex !== -1 || this.editParams.replyIndex !== -1) {
                return;
            }

            setTimeout(() => {
                this.editLabel = discussion.contents;

                this.editParams.discussionData = discussion;
                this.editParams.discussionIndex = index;
                const editDiscussion = this.discussionData.children[index];
                this.$set(editDiscussion, "isEdit", true);
            }, 100);
        },

        // 编辑回复
        handleEditItem(discussion, discussionIndex, reply, replyIndex) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            if (this.editParams.discussionIndex !== -1 || this.editParams.replyIndex !== -1) {
                return;
            }

            setTimeout(() => {
                this.editParams.discussionData = discussion;
                this.editParams.discussionIndex = discussionIndex;
                this.editParams.replyData = reply;
                this.editParams.replyIndex = replyIndex;

                const replyDiscussion = this.discussionData.children[discussionIndex].children[replyIndex];
                this.editLabel = replyDiscussion.contents;
                this.$set(replyDiscussion, "isEdit", true);
            }, 100);
        },

        // 回复话题-回复楼主
        handleReplyLandlord(discussion, index) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            setTimeout(() => {
                this.replyParams.discussionData = discussion;
                this.replyParams.discussionIndex = index;
                const replyDiscussion = this.discussionData.children[index];

                this.$set(replyDiscussion, "isReply", true);
            });
        },

        // 回复话题-回复用户
        handleReplyItem(discussion, discussionIndex, reply, replyIndex) {
            if (this.status === 0) {
                this.$message.warning("实训已结束");
                return;
            }

            setTimeout(() => {
                this.replyParams.discussionData = discussion;
                this.replyParams.discussionIndex = discussionIndex;
                this.replyParams.replyData = reply;
                this.replyParams.replyIndex = replyIndex;

                const replyDiscussion = this.discussionData.children[discussionIndex].children[replyIndex];

                this.$set(replyDiscussion, "isReply", true);
            }, 100);
        },

        // 点击其他区域关闭回复框-重置回复数据
        clearReplyInput() {
            let replyDiscussion = this.discussionData.children[this.replyParams.discussionIndex];

            if (this.replyParams.replyIndex !== -1) {
                replyDiscussion = replyDiscussion.children[this.replyParams.replyIndex];
            }

            this.$set(replyDiscussion, "isReply", false);

            this.replyParams = {
                discussionData: null,
                discussionIndex: -1,
                replyData: null,
                replyIndex: -1,
            };
            this.replyLabel = "";
        },

        // 确认回复
        handleReplyConfirm() {
            if (!this.replyLabel) {
                this.$message.warning("请输入回复内容");
                return;
            }

            let replyDiscussion = this.discussionData.children[this.replyParams.discussionIndex];

            if (this.replyParams.replyIndex !== -1) {
                replyDiscussion = replyDiscussion.children[this.replyParams.replyIndex];
            }

            const params = {
                id: replyDiscussion.activities_id,
                parent_id: replyDiscussion.id,
                contents: this.replyLabel,
            };

            this.$shttp.axiosPost(
                this.$api.discuss_add,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.clearReplyInput();
                        this.getDiscussionList();
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        // 关闭编辑弹框-重置编辑弹框数据
        clearEditInput() {
            let editDiscussion = this.discussionData.children[this.editParams.discussionIndex];

            if (this.editParams.replyIndex !== -1) {
                editDiscussion = editDiscussion.children[this.editParams.replyIndex];
            }

            this.editParams = {
                discussionData: null,
                discussionIndex: -1,
                replyData: null,
                replyIndex: -1,
            };

            this.editLabel = "";
        },

        // 确认编辑回复
        handieEditConfirm() {
            if (!this.editLabel) {
                this.$message.warning("内容不能为空");
                return;
            }

            let editDiscussion = this.discussionData.children[this.editParams.discussionIndex];

            if (this.editParams.replyIndex !== -1) {
                editDiscussion = editDiscussion.children[this.editParams.replyIndex];
            }

            const params = {
                id: editDiscussion.activities_id,
                discuss_id: editDiscussion.id,
                contents: this.editLabel,
            };

            this.$shttp.axiosPost(
                this.$api.discuss_edit,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.clearEditInput();
                        this.getDiscussionList();
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .el-textarea .el-textarea__inner {
    /* 设置滚动条的宽度 */
    &::-webkit-scrollbar {
        width: 8px; /* 垂直滚动条宽度 */
        height: 8px; /* 水平滚动条高度 */
    }

    /* 设置滚动条轨道样式 */
    &::-webkit-scrollbar-track {
        background-color: transparent; /* 轨道颜色 */
        border-radius: 8px;
    }

    /* 设置滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
        background-color: #d4d5d7; /* 滑块颜色 */
        border-radius: 8px;
    }

    /* 滑块悬停时的样式 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #c1c3c6; /* 悬停时的颜色 */
    }
}

.topic-discussion {
    width: 100%;
    height: calc(100vh - 112px - 103px);
    padding: 20px;
    box-sizing: border-box;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;
        &::-webkit-scrollbar {
            display: none;
        }
    }

    &_publish {
        background-color: #ffffff;
        padding: 24px 40px;
        border-radius: 4px;

        .publish-title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.9);
            line-height: 22px;
            word-break: break-all;
        }
    }

    .publish-input {
        display: flex;
        gap: 10px;
        margin-top: 40px;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    .publish-operate {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;

        .primary-button {
            width: 88px;
            height: 36px;
            background-color: #006eff;
            color: #ffffff;
            display: flex;
            align-content: center;
            justify-content: center;
        }
    }

    &_box {
        background-color: #ffffff;
        padding: 24px 40px;
        margin-top: 20px;
        border-radius: 4px;

        // ::v-deep .el-scrollbar__wrap {
        //     margin: 0 !important;
        //     background-color: #ffffff;
        //     padding: 24px 40px;
        //     border-radius: 4px;
        //     box-sizing: border-box;
        //     max-height: calc(100vh - 274px - 70px - 112px - 60px);

        //     &::-webkit-scrollbar {
        //         display: none;
        //     }
        // }

        .discussion-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: calc(100vh - 386px - 70px - 160px);
            gap: 20px;

            img {
                width: 200px;
                height: 182px;
                object-fit: cover;
            }

            span {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                line-height: 16px;
            }
        }

        .discussion-count {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 16px;
            margin-bottom: 16px;

            span {
                color: #000000;
            }
        }

        .discussion-item {
            &:not(.discussion-item:last-of-type) {
                margin-bottom: 60px;
            }

            &_landlord {
                display: flex;
                gap: 10px;
                margin-bottom: 10px;

                .landlord-img {
                    width: 52px;
                    height: 52px;
                    object-fit: cover;
                    border-radius: 50%;
                }

                .landlord-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    flex: 1;

                    &_top {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #333333;
                        line-height: 16px;

                        .top-sticky {
                            background-color: #ff6666;
                            font-size: 12px;
                            color: #ffffff;
                            padding-inline: 2px;
                            border: 1px solid #ffffff;
                            border-radius: 2px;
                        }

                        .top-name {
                            color: #ff8000;

                            &::after {
                                content: "：";
                                color: #333333;
                            }
                        }

                        .top-text {
                            word-break: break-all;
                        }

                        &.flex {
                            display: flex;

                            .top-name {
                                flex-shrink: 0;
                            }
                        }
                    }

                    &_bottom {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .bottom-time {
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #939393;
                            line-height: 16px;

                            &-operate {
                                color: #006eff;
                                margin-left: 6px;
                                cursor: pointer;
                            }
                        }

                        .bottom-operate {
                            display: flex;
                            align-items: center;
                            gap: 16px;

                            .iconfont {
                                cursor: pointer;

                                &.is-digg {
                                    color: #ff6800;
                                }
                            }

                            &_comment {
                                i.iconfont {
                                    font-size: 14px;
                                    margin-right: 3px;
                                }
                            }

                            &_more {
                                .el-icon-more {
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

            &_comment {
                box-sizing: border-box;
                padding-left: 62px;
                // min-height: 300px;
                position: relative;

                &::before {
                    content: "";
                    position: absolute;
                    left: 60px;
                    top: 0;
                    width: 2px;
                    height: 100%;
                    background-color: #f2f2f2;
                }

                .publish-input {
                    margin-top: 0;
                    margin-left: 6px;
                }

                .publish-operate {
                    margin-bottom: 10px;
                }

                .comment-item {
                    margin-left: 6px;

                    &:not(.comment-item:last-of-type) {
                        margin-bottom: 16px;
                    }

                    .publish-input {
                        margin-top: 10px;
                    }

                    .publish-operate {
                        margin-bottom: 0;
                    }

                    &_top {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #333333;
                        line-height: 16px;

                        &.flex {
                            display: flex;
                        }

                        .top-name {
                            color: #ff8000;
                            flex-shrink: 0;

                            &-reply {
                                color: #666666;
                            }

                            &::after {
                                content: "：";
                                color: #333333;
                            }
                        }

                        .top-text {
                            word-break: break-all;
                        }
                    }

                    &_bottom {
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .bottom-time {
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #939393;
                            line-height: 16px;

                            &-operate {
                                margin-left: 6px;
                                cursor: pointer;

                                &.comment,
                                &.edit {
                                    color: #006eff;
                                }

                                &.delete {
                                    color: #ff0000;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
